import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/fetchWerklijsten'
import type { FetchWerklijsten } from '../types/FetchWerklijsten'

export { useWerklijstenStore }

const useWerklijstenStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<FetchWerklijsten['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
